import { z } from 'zod';
/**
 * Política de ingreso de la entidad (GUIA-AGENTES.md §3.11). La aplica la suite al entrar a una app de la entidad;
 * las apps conectadas no tienen política propia (sesión, bloqueo, MFA): eso es de la suite.
 */
export const loginPolicySchema = z.object({
    /**
     * `false`: las personas de la entidad entran solo con el ingreso institucional (Entra, Google…), nunca con
     * contraseña de la suite. Los superadministradores no se ven afectados.
     */
    allowPassword: z.boolean().default(true),
    /** Exigir verificación en dos pasos a quien entra con contraseña, aunque la suite no la exija a todos. */
    requireMfa: z.boolean().default(false),
});
export const DEFAULT_LOGIN_POLICY = { allowPassword: true, requireMfa: false };
//# sourceMappingURL=politica.js.map